var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.QrCodeUrl)?_c('img',{staticClass:"QRcode",attrs:{"src":_vm.QrCodeUrl,"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }